import React from 'react'
import Badge from 'gu-ui-kit/Badge'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import styles from 'components/BetaLabel/BetaLabel.module.scss'

const BetaLabel = ({ size = 's', className, children }) => (
  <Badge
    noWrap
    className={clsx(styles['beta-label'], className)}
    color={'Label-Onsurface'}
    size={'xs'}
    variant={size === 'm' ? 'Body-20' : 'Body-10'}
  >
    {children}
  </Badge>
)

BetaLabel.propTypes = {
  size: PropTypes.oneOf(['s', 'm']),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default BetaLabel
